"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var searchResultItemBaseTheme = function (_a) {
    var _b;
    var MAX_S = _a.MAX_S;
    return ({
        searchResultItem: {},
        searchResultBreadcrumbs: {},
        searchResultItemHighlights: {},
        searchResultSubTitle: {},
        searchResultItemHref: {
            marginBottom: "1rem",
            display: "block",
            fontWeight: 900,
            fontSize: "1.125rem",
        },
        searchResultMetadata: (_b = {},
            _b[MAX_S] = {
                padding: "0 1rem"
            },
            _b.marginTop = "0.625rem",
            _b.display = "flex",
            _b.flexWrap = "wrap",
            _b),
        searchResultMetadataItem: {
            margin: "4px 16px 4px 0px",
            padding: "4px 8px 4px 8px",
            borderRadius: "1.25rem",
            fontSize: "11px",
        },
    });
};
exports.default = searchResultItemBaseTheme;
//# sourceMappingURL=searchResultItem.js.map